//CHECKED
import React, { PropsWithChildren, useContext, useState } from "react";
import styled from "styled-components";
import { getDistance } from "../functions/getDistance";
import lang from "../functions/lang";
import { sortStores } from "../functions/sortStores";
import { Store } from "../interfaces/IStore";
import { LocateMeButton } from "./LocateMeButton";
import { MapContext } from "./MapContext";
import { SearchBar } from "./SearchBar";
import { Title } from "./Title";
const HeaderDiv = styled.div``;
// padding: 0.6rem 0.4rem;

const Container = styled.div`
  display: flex;
  flex-flow: column;
  align-content: center;
`;
const ErrorContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-content: center;
  padding: 1rem;
  font-weight: 400;
  font-size: 14px;
  color: #522398;
`;

interface IHeader {
  setSearchError: (searchError: boolean) => void;
}
export const Header = ({ setSearchError }: PropsWithChildren<IHeader>) => {
  const { setCoords, setSortCoords, stores, setDefaultZoom } = useContext(
    MapContext
  );
  const geolocate = () => {
    navigator.geolocation.getCurrentPosition((res) => {
      const result = {
        lat: res.coords.latitude,
        lng: res.coords.longitude,
      };
      const closestStore = sortStores(result, stores)[0];
      const distance = getDistance(
        [closestStore.latitude, closestStore.longitude],
        [res.coords.latitude, res.coords.longitude]
      );
      switch (true) {
        case distance <= 50000:
          setDefaultZoom(11);
          setCoords(result);
          break;
        default:
          setSearchError(true);
          setDefaultZoom(10);
          setCoords(result);
          break;
      }
      setSortCoords(result);
    });
  };

  return (
    <HeaderDiv>
      <Title />
      <Container>
        <SearchBar viewPort="desktop" setSearchError={setSearchError} />
        <LocateMeButton onClick={geolocate} />
      </Container>
    </HeaderDiv>
  );
};
